export default () => ({
  trigger: {
    name: 'promo_labels.show_promo_label',
    params: {},
  },
  config: {
    event: {
      name: 'show_content',
      params: {
        sub_feature: null,
      },
    },
    nonInt: true,
  },
});
